module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product24-368cdb72b2d71b759bc76b1f8bbe9b22.jpg";